module.exports = __webpack_public_path__ + "files/5a8749914d91c3791529aa8bed150a5a.png";